import Vue from 'vue';
import { createFrozenMap } from '@/vuex/utils';
import { fetchUserJourneyTasks } from './user-journey.utils';
import values from 'lodash/values';

let loadAllPromise;
const pollingInterval = 6000;

export default {
    namespaced: true,
    state: {
        error: {},
        fetching: false,
        map: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setMapAtKey (state, { id, task }) {
            Vue.set(state.map, id, task);
        },
        deleteMapKey (state, { id }) {
            Vue.delete(state.map, id);
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        init ({ dispatch }) {
            dispatch('startPollingForPreInstallChecklistComplete');
        },
        async loadAll ({ commit }, { reFetch = false } = {}) {
            if (loadAllPromise && reFetch !== true) {
                await loadAllPromise;

                return;
            }

            commit('setFetching', { fetching: true });
            loadAllPromise = fetchUserJourneyTasks();

            try {
                const { data: tasks } = await loadAllPromise;
                commit('setFetching', { fetching: false });
                commit('setMap', {
                    map: createFrozenMap(tasks),
                });
            } catch (error) {
                loadAllPromise = null;
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
        async pollForPreinstallOnboardingChecklistComplete ({ dispatch, getters }, { intervalRef }) {
            await dispatch('loadAll', { reFetch: true });
            const checklist = getters.getChecklistByName('preinstallOnboarding');
            if (checklist?.isComplete) {
                dispatch('onPreInstallChecklistCompletion');

                if (intervalRef) clearInterval(intervalRef);
            }
        },
        async startPollingForPreInstallOnboardingComplete ({ dispatch, getters }) {
            await dispatch('loadAll');

            const checklist = getters.getChecklistByName('preinstallOnboarding');
            if (!checklist) return;

            if (checklist.isComplete) {
                dispatch('onPreInstallChecklistCompletion');

                return;
            }

            const intervalRef = setInterval(() => {
                dispatch('pollForPreinstallOnboardingChecklistComplete', { intervalRef });
            }, pollingInterval);
        },
        onPreInstallChecklistCompletion ({ dispatch }) {
            const guide = pendo?.guides?.find((guide) => guide?.name === 'PLG | Trial extended from installation');

            if (guide && !guide?.hasBeenSeen()) {
                guide.show();
                dispatch('subscription/loadActiveSubscription', null, { root: true });
            }
        },
        startPollingForPreInstallChecklistComplete ({ dispatch, rootState }) {
            const { featureFlags, isInTrial } = rootState.subscription.active;

            if (isInTrial && featureFlags.hadUpfrontTrial) {
                dispatch('startPollingForPreInstallOnboardingComplete');
            }
        },
    },
    getters: {
        getChecklistByName: (state, getters) => (name) => getters.list.find((task) => task.name === name),
        list: (state) => values(state.map),
    },
};
